import { isFuture } from "shelving";
import { DEMOTE_MEMBER, PROMOTE_MEMBER, REMOVE_MEMBER, UNMUTE_MEMBER } from "shared/api";
import { Button, ModalButton } from "shared/react";
import { NON_MEMBER, isAdminMember, isOwnerMember } from "shared/schema";
import { getCallAPIWithNotice } from "../util/api.js";
import { useMemberItem } from "../util/data.js";
import { MemberBlockForm } from "./MemberBlockForm.js";
import { MemberMuteForm } from "./MemberMuteForm.js";

export function MemberMenu({ gid, uid }: { gid: string; uid: string }): React.ReactElement {
	const { status: youStatus } = useMemberItem(gid).value || NON_MEMBER;
	const member = useMemberItem(gid, uid);

	// Data for the targeted user.
	const { muted, status: memberStatus } = member.data;

	return (
		<nav>
			{isAdminMember(youStatus) && memberStatus !== "blocked" ? <ModalButton modal={<MemberBlockForm gid={gid} uid={uid} />}>Ban member</ModalButton> : null}
			{isAdminMember(youStatus) && memberStatus === "member" ? (
				typeof muted === "number" && isFuture(muted) ? (
					<Button onClick={getCallAPIWithNotice(UNMUTE_MEMBER, { gid, uid })}>Unmute member</Button>
				) : (
					<ModalButton modal={<MemberMuteForm gid={gid} uid={uid} />}>Mute member</ModalButton>
				)
			) : null}
			{isOwnerMember(youStatus) && memberStatus === "admin" ? <Button onClick={getCallAPIWithNotice(PROMOTE_MEMBER, { gid, uid })}>Promote to owner</Button> : null}
			{isOwnerMember(youStatus) && memberStatus === "admin" ? <Button onClick={getCallAPIWithNotice(DEMOTE_MEMBER, { gid, uid })}>Demote admin</Button> : null}
			{isOwnerMember(youStatus) && memberStatus === "member" ? <Button onClick={getCallAPIWithNotice(PROMOTE_MEMBER, { gid, uid })}>Promote to admin</Button> : null}
			{isAdminMember(youStatus) ? <Button onClick={getCallAPIWithNotice(REMOVE_MEMBER, { gid, uid })}>Remove from group</Button> : null}
		</nav>
	);
}
